import { render, staticRenderFns } from "./BaseHeadline.vue?vue&type=template&id=181a4e74&"
import script from "./BaseHeadline.vue?vue&type=script&lang=js&"
export * from "./BaseHeadline.vue?vue&type=script&lang=js&"
import style0 from "./BaseHeadline.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports